import { useCallback, useEffect, useState } from 'react'

import {
  actions as builderActions,
  WizardState
} from '../../../../tradebuilder-v2/modules/00-builder/state/builder-slice'
import { useAppDispatch, useAppSelector } from '../../../../tradebuilder-v2/store/hooks'
import { useActions } from '../../../../tradebuilder-v2/store/use-actions'
import {
  actions as approveActions,
  postTradeApprove,
  postTradeReject
} from '../state/trade-approve-slice'
import TradeApproveStateless from '../templates/trade-approve-stateless'

const TradeApprove = () => {
  const builderState = useAppSelector(state => state.builder)
  const state = useAppSelector(state => state.tradeApprove)
  const actions = useActions(approveActions)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const dispatch = useAppDispatch()

  const initialise = useCallback(
    (builder: WizardState) => {
      setIsLoading(true)
      actions.reset()
      actions.initialise({
        userName: builder.userName,
        userType: builder.userType,
        userRoles: builder.userRoles,
        accountId: builder.accountId,
        tradeDocumentationUrl:
          builderState.savedState.account.tradeDocumentation.at(-1)?.relativeUrl,
        approvalEvents: builder.approvalEvents,
        status: builder.status
      })
    },
    [actions, builderState.savedState.account.tradeDocumentation]
  )

  useEffect(() => {
    initialise(builderState)
  }, [builderState, initialise])
  useEffect(() => {
    initialise(builderState)
  }, [builderState.approvalEvents, builderState.accountId, initialise, builderState])

  useEffect(() => {
    if (state.accountId === builderState.selectedAccountId) {
      setIsLoading(false)
    }
  }, [builderState.selectedAccountId, state.accountId, state.approvalEvents])
  useEffect(() => {
    if (state.accountId === builderState.selectedAccountId && state.success === true) {
      dispatch(
        builderActions.refreshTradeStatus(state.accountId, {
          title: 'The trade has been successfully approved'
        })
      )
    }
  }, [builderState.selectedAccountId, dispatch, state.success, state.accountId])
  useEffect(() => {
    if (state.accountId === builderState.selectedAccountId && state.rejectSuccess === true) {
      dispatch(
        builderActions.refreshTradeStatus(state.accountId, {
          title: 'The trade has been rejected'
        })
      )
    }
  }, [builderState.selectedAccountId, dispatch, state.rejectSuccess, state.accountId])

  const onTradeApprove = (comments: string) => {
    dispatch(postTradeApprove(state.accountId, comments))
  }
  const onTradeReject = comments => {
    dispatch(postTradeReject(state.accountId, comments))
  }

  if (!isLoading) {
    return (
      <TradeApproveStateless
        state={state}
        onTradeApproved={onTradeApprove}
        onTradeReject={onTradeReject}
      />
    )
  }
  return null
}

export default TradeApprove
